(function(){
  'use strict';
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.dulceria-pdp').forEach(initPDP);
  });

  function initPDP(root){
    // Gallery thumb swap
    var thumbs = root.querySelectorAll('.dulceria-pdp__thumb');
    var heroImg = root.querySelector('[data-hero-img]');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        thumbs.forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-img-src');
        if(heroImg && src) heroImg.src = src;
      });
    });

    // Qty
    var qInput = root.querySelector('[data-qty-input]');
    var qMinus = root.querySelector('[data-qty-minus]');
    var qPlus = root.querySelector('[data-qty-plus]');
    if(qMinus) qMinus.addEventListener('click', function(){
      var v = parseInt(qInput.value, 10) || 1; if(v > 1) qInput.value = v - 1;
    });
    if(qPlus) qPlus.addEventListener('click', function(){
      var v = parseInt(qInput.value, 10) || 1; if(v < 99) qInput.value = v + 1;
    });

    // Variant selection
    var variantsHolder = root.querySelector('[data-variants-json]');
    if(!variantsHolder) return;
    var variants = [];
    try { variants = JSON.parse(variantsHolder.getAttribute('data-variants-json')); } catch(e){ return; }
    var variantInput = root.querySelector('[data-variant-input]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('.dulceria-pdp__add');

    function getSelected(){
      var sel = [];
      root.querySelectorAll('.var-group').forEach(function(group){
        var active = group.querySelector('.var-btn.active');
        sel.push(active ? active.getAttribute('data-option-value') : null);
      });
      return sel;
    }

    function arraysEqual(a, b){
      if(a.length !== b.length) return false;
      for(var i=0; i<a.length; i++) if(a[i] !== b[i]) return false;
      return true;
    }

    function update(){
      var sel = getSelected();
      var match = variants.find(function(v){
        return arraysEqual(v.options, sel);
      });
      if(match){
        variantInput.value = match.id;
        if(priceEl){
          var price = match.price;
          var formatted = (price/100).toLocaleString('de-AT', { style: 'currency', currency: 'EUR' });
          priceEl.textContent = formatted;
        }
        if(addBtn){
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'In den Warenkorb →' : 'Ausverkauft';
        }
      } else if(addBtn){
        addBtn.disabled = true;
        addBtn.textContent = 'Nicht verfügbar';
      }
    }

    root.querySelectorAll('.var-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.closest('.var-group');
        group.querySelectorAll('.var-btn').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        update();
      });
    });
  }
})();
